import { create } from 'zustand'

const useLoadingStore = create((set, get) => ({
    isLoading: false,
    setLoading: (value) => set((state) => {
        return { isLoading: value }
    }),
}))

export default useLoadingStore;